import axios from "axios";
import { SendMessageDataType } from "common/types";
import { alyviaCoreServiceApi } from "utils/constants";

export function sendTextMessage(messageData: SendMessageDataType) {
	return axios.post(`${alyviaCoreServiceApi}/messages/send`, messageData)
		.then((response) => response.data)
}

export function readMessages(conversationId: string, deviceId: string) {
	return axios.post(`${alyviaCoreServiceApi}/messages/markAllReceivedMessageAsRead`, { conversationId, deviceId })
		.then((response) => response.data)
}

export function sendMessageWithMedia(messageData: SendMessageDataType, file: File | Blob) {
	const formData = new FormData();
	Object.keys(messageData).forEach((key) => {
		formData.append(key, (messageData as any)[key]);
	});
	formData.append('file', file);
	return axios.post(`${alyviaCoreServiceApi}/messages/sendMedia`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	}).then((response) => response.data);
}
